import React from 'react';
import { alto, dustGray, LAYOUTS, Loader, Progress } from '@parchment/atoms';
import { ThrobberDarkIcon } from '@parchment/icons';
import styled from 'styled-components';
import { MODAL_STATE } from '../Modal';
const ModalBody = _ref => {
  let {
    bodyId,
    modalBodyRef,
    bodyIcon,
    defaultIcon,
    modalState,
    loadingContent,
    loadingMessage,
    loadingProgressValue,
    loadingProgressMax,
    children
  } = _ref;
  let modalBodyContent = /*#__PURE__*/React.createElement(React.Fragment, null, (bodyIcon || defaultIcon) && /*#__PURE__*/React.createElement(BodyIconWrapper, null, bodyIcon || defaultIcon), children);
  if (modalState !== MODAL_STATE.DEFAULT) {
    let loader;
    switch (modalState) {
      case MODAL_STATE.PROCESSING_WITH_SPINNER:
        loader = /*#__PURE__*/React.createElement(LoadingAnimationWrapper, {
          className: "ui-modal__loading-spinner",
          "data-testid": "modal-loader-spinner"
        }, /*#__PURE__*/React.createElement(Loader, {
          loading: true,
          size: "3.75rem",
          layout: LAYOUTS.VERTICAL,
          loadingMessage: loadingMessage
        }));
        break;
      case MODAL_STATE.PROCESSING_WITH_LEGACY_SPINNER:
        loader = /*#__PURE__*/React.createElement(LoadingAnimationWrapper, {
          className: "ui-modal__loading-spinner",
          "data-testid": "modal-legacy-loader-spinner"
        }, /*#__PURE__*/React.createElement(LegacyContainer, null, /*#__PURE__*/React.createElement(LegacyLoaderContainer, null, /*#__PURE__*/React.createElement(StyledLoaderIcon, {
          contextType: "image",
          size: "3.75rem",
          spin: true
        }), loadingMessage && /*#__PURE__*/React.createElement(LegacyLoadingMessage, null, loadingMessage))));
        break;
      case MODAL_STATE.PROCESSING_WITH_PROGRESS:
        if (loadingProgressValue == null || loadingProgressMax == null) {
          console.warn('Some properties missing here, both `loadingProgressValue` and `loadingProgressMax` are needed');
        }
        loader = /*#__PURE__*/React.createElement(ProgressAnimationWrapper, {
          className: "ui-modal__loading-progress",
          "data-testid": "modal-loading-progress"
        }, /*#__PURE__*/React.createElement(Progress, {
          label: "percent",
          max: loadingProgressMax,
          value: loadingProgressValue
        }));
        break;
    }
    modalBodyContent = /*#__PURE__*/React.createElement(React.Fragment, null, loader, /*#__PURE__*/React.createElement(LoadingContentWrapper, null, loadingContent ? loadingContent : /*#__PURE__*/React.createElement(LoadingContentInner, null, /*#__PURE__*/React.createElement(Bold, null, "Some process is happening."), /*#__PURE__*/React.createElement(LoadingContentNote, null, /*#__PURE__*/React.createElement("div", null, "This window will close when the process is complete."), /*#__PURE__*/React.createElement("div", null, "Please stay on this page, and don\u2019t refresh this page while this process is running.")))));
  }
  return /*#__PURE__*/React.createElement(ModalBodyWrapper, {
    id: bodyId,
    ref: modalBodyRef,
    "data-testid": "modal-body-wrapper",
    className: "ui-modal-body-wrapper",
    tabIndex: modalState !== MODAL_STATE.DEFAULT ? 0 : undefined
  }, modalBodyContent);
};
const ModalBodyWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__ModalBodyWrapper",
  componentId: "sc-11ajnts-0"
})(["flex:1 1;padding:40px;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;text-align:justify;font-size:16px;overflow-y:auto;outline:0;[class*=\"Tooltip__TooltipContainer\"]{position:relative;}"]);
const BodyIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__BodyIconWrapper",
  componentId: "sc-11ajnts-1"
})(["flex-shrink:0;width:120px;height:120px;font-size:60px;background-color:", ";color:", ";border-radius:50%;display:inline-flex;justify-content:center;flex-direction:column;align-items:center;margin:0 0 15px;svg{width:.75em;height:.75em;top:0;}"], _ref2 => {
  var _theme$whiteSpace;
  let {
    theme
  } = _ref2;
  return (theme === null || theme === void 0 ? void 0 : (_theme$whiteSpace = theme.whiteSpace) === null || _theme$whiteSpace === void 0 ? void 0 : _theme$whiteSpace.zIndex4) || alto;
}, _ref3 => {
  var _theme$whiteSpace2;
  let {
    theme
  } = _ref3;
  return (theme === null || theme === void 0 ? void 0 : (_theme$whiteSpace2 = theme.whiteSpace) === null || _theme$whiteSpace2 === void 0 ? void 0 : _theme$whiteSpace2.base) || dustGray;
});
const Bold = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__Bold",
  componentId: "sc-11ajnts-2"
})(["font-weight:700;"]);
const LoadingContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LoadingContentWrapper",
  componentId: "sc-11ajnts-3"
})(["margin-top:1.375rem;"]);
const LoadingContentInner = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LoadingContentInner",
  componentId: "sc-11ajnts-4"
})(["text-align:center;"]);
const LoadingContentNote = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LoadingContentNote",
  componentId: "sc-11ajnts-5"
})(["margin-top:0.625rem;"]);
const LoadingAnimationWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LoadingAnimationWrapper",
  componentId: "sc-11ajnts-6"
})(["margin:1.75rem 0 0;"]);
const ProgressAnimationWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__ProgressAnimationWrapper",
  componentId: "sc-11ajnts-7"
})(["width:100%;max-width:30rem;margin:3.75rem 0;"]);
const LegacyContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LegacyContainer",
  componentId: "sc-11ajnts-8"
})(["position:relative;overflow:hidden;"]);
const LegacyLoaderContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LegacyLoaderContainer",
  componentId: "sc-11ajnts-9"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;&:before{content:'';display:block;position:absolute;width:100%;height:100%;left:0;top:0;}"]);
const LegacyLoadingMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalBody__LegacyLoadingMessage",
  componentId: "sc-11ajnts-10"
})(["position:relative;"]);
const StyledLoaderIcon = /*#__PURE__*/styled(ThrobberDarkIcon).withConfig({
  displayName: "ModalBody__StyledLoaderIcon",
  componentId: "sc-11ajnts-11"
})(["margin:10px;"]);
export default ModalBody;